import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../shared/shared.module';
import { OperationGenericCommentsPage } from './operation-generic-comments';
import { OperationGenericCommentPage } from '../operation-generic-comment/operation-generic-comment';
import { OperationGenericCommentPageModule } from '../operation-generic-comment/operation-generic-comment.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OperationGenericCommentsPage
  ],
  imports: [
    IonicPageModule.forChild(OperationGenericCommentsPage),
    IonicPageModule.forChild(OperationGenericCommentPage),
    SharedModule,
    OperationGenericCommentPageModule,
    DirectivesModule,
  ],
})
export class OperationGenericCommentsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-generic-comments/operation-generic-comments.module.ts